(ns kyber.components.composite.select
  (:require
   [reagent.core :as reagent]

   [kyber.components.base.text :as text]
   [kyber.components.base.button :as button]
   [kyber.styles.core :refer [gs styles->classes]]))

(def custom-select-height 42)
(def custom-select-default-width 250)
(def custom-select-z-index 10)

(def classes
  (styles->classes
   {:custom-select-container
    {:border (str "1px solid " (gs [:colors :gray-scale-300]))
     :border-radius (gs [:radius :r3])
     :background-color (gs [:colors :true-white])
     :min-width (str custom-select-default-width "px")
     :position :relative
     :display :flex
     :justify-content :space-between
     :height (str custom-select-height "px")
     :transition "all ease-in-out 0.3s"

     "&:hover"
     {:box-shadow (gs [:shadows :shadow-6])}

     "& button"
     {:cursor :pointer
      :outline :none
      :background :none
      :border :none
      :font-size "12px"
      :font-weight (gs [:font-weight :body-20])
      :font-family (gs [:font-family :open-sans])
      :color (gs [:colors :gray-scale-500])
      :text-align :left
      :width "100%"
      :overflow :hidden}}

    :custom-select-selected-option
    {:width "100%"
     :white-space :nowrap}

    :custom-select-list-container
    {:display :none
     :position :absolute
     :top (str (- custom-select-height 1) "px")
     :left 0
     :background-color (gs [:colors :true-white])
     :border-radius (gs [:radius :r3])
     :box-shadow (gs [:shadows :shadow-12])
     :width "100%"
     :z-index custom-select-z-index
     :max-height "300px"
     :overflow-y :scroll}

    :custom-select-list-container-highlight-deselect
    {"& > *:first-child"
     {:background-color (gs [:colors :gray-scale-100])

      "& button span"
      {:color (gs [:colors :gray-scale-400])}}}

    :custom-select-list-container-open
    {:display "block !important"}

    :custom-select-list-item
    {:width "100%"

     "& button"
     {:width "100%"
      :padding [(gs [:spacing :p12])
                (gs [:spacing :p4])]}

     "&:hover"
     {:background (gs [:colors :primary-lite-600])

      "& button span"
      {:color (gs [:colors :true-white])}}}

    :custom-select-list-item-active
    {:background-color (str (gs [:colors :primary-lite-400]) " !important")
     "& > button span"
     {:color (str (gs [:colors :true-white]) " !important")}}}))

(defn render
  [{:keys [on-change
           default-value
           style
           list-styles
           custom-select-style
           label
           custom-display]
    :or {on-change identity}}]
  (let [current-value (reagent/atom default-value)
        is-open (reagent/atom false)
        ;; Used to differentiate different dropdown events
        dropdown-id (str (random-uuid))
        close-dropdown #(when (and (true? @is-open)
                                   (not= dropdown-id (.-data %)))
                          (reset! is-open false))]
    (reagent/create-class
     {:component-did-mount
      (fn []
        (.addEventListener js/window "click" close-dropdown))

      :component-will-unmount
      (fn []
        (.removeEventListener js/window "click" close-dropdown))

      :reagent-render
      (fn [{:keys [options]}]
        (let [selected-choice (->> options
                                   (filter #(= @current-value (:value %)))
                                   (first))]
          [:div (cond-> {}
                  (some? style)
                  (assoc :style style))
           (when (some? label)
             [text/title-10 :p label])
           [:div (cond-> {:class (:custom-select-container classes)}
                   (some? custom-select-style)
                   (assoc :style custom-select-style))
            [:button
             {:class (:custom-select-selected-option classes)
              :aria-haspopup "listbox"
              :aria-expanded (str @is-open)
              :on-click #(do
                           (set! (.-data (.-nativeEvent %)) dropdown-id)
                           (.preventDefault %)
                           (swap! is-open not))}
             (if (some? custom-display)
               [custom-display (:display selected-choice)]
               [:span (:display selected-choice)])]
            [button/icon-button
             {:on-click #(do
                           (set! (.-data (.-nativeEvent %)) dropdown-id)
                           (.preventDefault %)
                           (swap! is-open not))
              :style {:width :auto}}
             (if @is-open :chevron-up :chevron-down)]
            [:ul (cond-> {:class [(:custom-select-list-container classes)]
                          :role "listbox"}
                   (true? @is-open)
                   (update :class
                           conj
                           (:custom-select-list-container-open classes))

                   (some? list-styles)
                   (update :style merge list-styles)

                   (-> options first :value (= :none))
                   (update :class
                           conj
                           (:custom-select-list-container-highlight-deselect
                            classes)))
             (doall
              (for [{:keys [value display]} options]
                ^{:key value}
                [:li
                 {:class (cond-> [(:custom-select-list-item classes)]
                           (= value @current-value)
                           (conj (:custom-select-list-item-active classes)))
                  :role "option"
                  :aria-selected (str (= value @current-value))}
                 [:button
                  {:on-click #(do
                                (set! (.-data (.-nativeEvent %)) dropdown-id)
                                (.preventDefault %)
                                (reset! is-open false)
                                (reset! current-value value)
                                (on-change value))}
                  (if (some? custom-display)
                    [custom-display display]
                    [:span display])]]))]]]))})))
